<template>
    <modal width="500px" :title="$t('dialogTitle.ImportRelay')" :visible.sync="isShowDialog">
        <el-upload
            class="upload-demo"
            drag
            action="#"
            :http-request="
                file => {
                    exportFile(file);
                }
            "
            :auto-upload="false"
            :limit="1"
            multiple
            ref="refFile"
            accept=".xlsx"
        >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                {{ $t('messageTitle.DragFilesHere') }}，{{ $t('messageTitle.Or') }}
                <em>{{ $t('messageTitle.ClickToUpload') }}</em>
            </div>
            <div class="el-upload__tip" slot="tip">{{ $t('messageTitle.UploadedFileCanOnlyBeInXlsx') }}</div>
        </el-upload>
        <div slot="footer">
            <el-button type="primary" @click="BatchDescribe">
                {{ $t('public.btn_confirm') }}
            </el-button>
        </div>
    </modal>
</template>

<script>
import { importRelay } from '@/api/modules/relay.js';
export default {
    props: ['isShowImDialog'],
    computed: {
        isShowDialog: {
            get: function() {
                return this.isShowImDialog;
            },
            set: function(val) {
                this.$emit('update:isShowImDialog', val);
            }
        }
    },
    methods: {
        exportFile(file) {
            const fd = new FormData();
            fd.append('uploadFile', file.file);
            importRelay(fd, { language: this.$i18n.locale }).then(async res => {
                await this.$resultHandle(res.state);
                this.isShowDialog = false;
            });
        },
        BatchDescribe() {
            this.$refs.refFile.submit();
        }
    }
};
</script>

<style></style>
